import React from 'react';
import { Container, Image } from 'semantic-ui-react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './Testimonials.css'


class Testimonials extends React.Component {
    constructor(props) {
        super(props)
        this.state = {} 
    }
    
    render() {
        return (
        <Carousel
        showArrows={true}
        infiniteLoop={false}
        showThumbs={false}
        showStatus={false}
        autoPlay={false}
        interval={7300}
        >
            <div>
                <div id="fonts" className="myCarousel testimonials-card-vertical">
                    <p style={{fontSize: "2rem"}}>
                        Had many people ask why i got so non-noisy lately
                    </p>
                    <p style={{ fontSize: "1rem"}}>
                        "Great Work! Love the app so far... had many people ask why i got so non-noisy lately"
                    </p>
                    <div className="testimonials-card-horizontal margin-50px">
                        {/* <img src="user1.png" /> */}
                        <div className="testimonials-card-vertical margin-10px ">
                            <h3 id="fonts">Jan O.</h3>
                            <h4 id="fonts">Germany</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div id="fonts" className="myCarousel testimonials-card-vertical">
                    <p style={{fontSize: "2rem"}}>
                    My audio-quality is way better than before and that was the goal!
                    </p>
                    <p style={{ fontSize: "1rem"}}>
                    "I mainly use Utterly to boost my audio during Zoom calls. 
                    As many others I was forced in the last year to find a place for work at home and in my case it’s a part of the basement with my old photo lights with big fans and the washing machine in the next room... 
                    I tested a few solutions and apps and ended up with Utterly and I’m really happy with the way it works. 
                    My audio-quality is way better than before and that was the goal!"
                    </p>
                    <div className="testimonials-card-horizontal margin-50px">
                        {/* <img src="user2.png" /> */}
                        <div className="testimonials-card-vertical margin-10px ">
                            <h3 id="fonts">Max</h3>
                            <h4 id="fonts">Germany</h4>
                        </div>
                    </div>
                </div> 
            </div>
            <div>
                <div id="fonts" className="myCarousel testimonials-card-vertical">
                    <p style={{fontSize: "2rem"}}>
                    I love Utterly, it has helped me a lot to reduce background noise when I record videos for YouTube
                    </p>
                    <p style={{ fontSize: "1rem"}}>
                    "I love Utterly, it has helped me a lot to reduce background noise when I record videos for YouTube. 
                    Since my room is near the street, a lot of noise can be heard and I have been struggling with that for a while before I found Utterly."
                    </p>
                    <div className="testimonials-card-horizontal margin-50px">
                        {/* <img src="user4.png" /> */}
                        <div className="testimonials-card-vertical margin-10px ">
                            <h3 id="fonts">Sebastian A.</h3>
                            <h4 id="fonts">Creator at YouTube</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div id="fonts" className="myCarousel testimonials-card-vertical">
                    <p style={{fontSize: "2rem"}}>
                    Great product and looking forward to the paid version!
                    </p>
                    <p style={{ fontSize: "1rem"}}> 
                    "I live near a freeway and thus have outside noise. 
                    I also work remotely and have had coworkers mention background noise when I speak. 
                    I tried Utterly and it's done a great job reducing background noise, according to my coworkers. 
                    Great product and looking forward to the paid version!"
                    </p>
                    <div className="testimonials-card-horizontal margin-50px">
                        {/* <img src="user3.png" /> */}
                        <div className="testimonials-card-vertical margin-10px ">
                            <h3 id="fonts">Alec L.</h3>
                            <h4 id="fonts">Business Analyst, US</h4>
                        </div>
                    </div>
                </div>
            </div>
        </Carousel>
        )
    }
}

export default Testimonials;
